import { useState } from "react";
import { Typography, Snackbar, Alert, LinearProgress } from "@mui/material";

const ResultsProcessing = () => {
  const [showSnackbar, setShowSnackbar] = useState(true);
  const onCloseSnackbar = () => {
    setShowSnackbar(false);
  };
  return (
    <>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ mt: 6 }}
        onClose={onCloseSnackbar}
      >
        <Alert
          onClose={onCloseSnackbar}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          File uploaded successfully
        </Alert>
      </Snackbar>
      <Typography
        variant="h6"
        className="upload-phase-text"
        sx={{ mb: 1, fontWeight: 600 }}
      >
        Processing...
      </Typography>
      <Typography
        variant="body2"
        className="upload-description-text"
        sx={{ mb: 2 }}
      >
        Please wait while we process your data
      </Typography>
      <LinearProgress sx={{ mb: 2, height: 8, borderRadius: 4 }} />
    </>
  );
};

export default ResultsProcessing;
